import Label from './Label'
export default Label;
export { Label }